
















































import { mapGetters } from "vuex";
import { General } from "@/utils/constants";
import ModalCapacityPermissionEdit from "@/views/App/ModalCapacityPermissionEdit.vue";
import { IUnityChild } from "@/components/types/unity";

export default {
  name: "ManageUnityRow",
  props: {
    row: {
      type: Object as () => IUnityChild,
      required: true
    },
    changeState: {
      type: Function,
      default: () => null
    },
    changeCollection: {
      type: Function,
      default: () => null
    },
    itemClass: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      General,
      enable: this.row.active
    };
  },

  computed: {
    ...mapGetters({
      getCapacityById: "getCapacityById",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    getAbbreviation() {
      const capacity = this.getCapacityById(this.row.id);
      return `${this.row.description}${
        capacity?.abbreviation ? " - " + capacity.abbreviation : ""
      }`;
    }
  },

  methods: {
    editPermission() {
      this.$buefy.modal.open({
        parent: this as any,
        component: ModalCapacityPermissionEdit as any,
        props: {
          capacity: [this.row]
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    checkCapacity(state: boolean) {
      this.changeState(this.row.id, state);
    },

    changeCollectionState(value: boolean) {
      this.changeCollection(this.row, value, () => {
        this.enable = !value;
      });
    }
  }
};
